import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { FormAccessor } from '@studiohyperdrive/ngx-forms';

import { RadioButtonComponent } from '@cjm/shared/ui/forms';

import { RadioValue } from './radio-group.types';

@Component({
	selector: 'vloket-radio-group',
	templateUrl: './radio-group.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => RadioGroupComponent),
			multi: true
		},
		{
			provide: NG_VALIDATORS,
			useExisting: forwardRef(() => RadioGroupComponent),
			multi: true
		}
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [RadioButtonComponent, ReactiveFormsModule]
})
export class RadioGroupComponent extends FormAccessor<string, FormControl<string>> {
	/**
	 * An attribute to provide values
	 */
	@Input() public values: RadioValue[] = [];
	/**
	 * The label allows the parent to set the label text
	 */
	@Input() public label: string;
	/**
	 * The hintLabel allows the parent to set the hint text
	 */
	@Input() public hintLabel: string;

	/**
	 * The groupName allows the parent to set the group name
	 */
	@Input({ required: true }) public groupName: string;

	// Denis: See: libs/shared/ui/forms/src/lib/abstracts/readme.md
	public initForm(): FormControl<string> {
		return new FormControl('');
	}
}
